module.exports = __webpack_public_path__ + "img/clouds-bg.b8429278.png";